const focusAreas = [
  {
    icon: 'ri-code-box-line',
    title: 'iOS Platform Engineering',
    description:
      'Deep expertise in the iOS ecosystem, building applications that leverage platform capabilities with native performance and seamless integration across devices and OS versions.',
  },
  {
    icon: 'ri-database-2-line',
    title: 'Scalable System Design',
    description:
      'Architecting distributed systems and data flows that maintain performance under growth, with careful attention to caching strategies, state management, and API design.',
  },
  {
    icon: 'ri-tools-line',
    title: 'Development Workflow',
    description:
      'Streamlined engineering processes incorporating continuous integration, automated testing pipelines, and code review practices that raise quality across every iteration.',
  },
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Technology Exploration',
    description:
      'Continuous investigation of emerging technologies and evolving standards, evaluating new approaches that can strengthen system architecture and improve development efficiency.',
  },
];

export default function FocusSection() {
  return (
    <section className="w-full bg-background-200/70 py-24 md:py-32 px-6 md:px-14">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-foreground-900 text-4xl md:text-5xl font-bold text-center leading-tight">
          Technical Focus
        </h2>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {focusAreas.map((area) => (
            <div
              key={area.title}
              className="rounded-xl bg-background-50 border border-background-300/50 p-6 flex flex-col"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-primary-100/70 text-primary-600 mb-6">
                <i className={`${area.icon} text-2xl`} />
              </div>
              <h3 className="font-heading text-foreground-900 text-lg font-bold leading-snug">
                {area.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mt-3 flex-1">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}